import '../../styles/admin/Billing.css';
import React from 'react';

const Billing = () => {

    return (
        <>
            <div className='container-fluid mt-1'>
                <div className='container-billing'>
                   <span className='current'>Current Balance: {0}</span>
                   <select id='select-billing' name='selectbilling' className='option-billing '>
                        <option value="30days">30 Days</option>
                        <option value="90days">90 Days</option>
                        <option value="180days">180 Days</option>
                        <option value="365days">365 Days</option>
                    </select>
                </div>
            </div>
        </>
    )
}

export default Billing;